"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

var _CarouselSlide = _interopRequireDefault(require("./CarouselSlide"));

var _CarouselControl = _interopRequireDefault(require("./CarouselControl"));

var _CarouselIndicator = _interopRequireDefault(require("./CarouselIndicator"));

var _CarouselLoading = _interopRequireDefault(require("./CarouselLoading"));

var _CarouselFallback = _interopRequireDefault(require("./CarouselFallback"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var THUMBNAIL_WIDTH = 70;

var getCarouselWidthForThumbs = function getCarouselWidthForThumbs(numberOfThumbs) {
  return 40 + THUMBNAIL_WIDTH * numberOfThumbs;
};

var sizeMap = {
  xs: {
    maxThumbs: 3,
    pxWidth: getCarouselWidthForThumbs(3)
  },
  s: {
    maxThumbs: 4,
    pxWidth: getCarouselWidthForThumbs(4)
  },
  m: {
    maxThumbs: 5,
    pxWidth: getCarouselWidthForThumbs(5)
  },
  l: {
    maxThumbs: 6,
    pxWidth: getCarouselWidthForThumbs(6)
  },
  xl: {
    maxThumbs: 7,
    pxWidth: getCarouselWidthForThumbs(7)
  }
};

var Carousel = function Carousel(props) {
  var loading = props.loading,
      size = props.size,
      pxSize = props.pxSize,
      minimal = props.minimal,
      children = props.children,
      onCarouselClick = props.onCarouselClick,
      fallbackPreview = props.fallbackPreview,
      hideIndicators = props.hideIndicators,
      showZoomOverlay = props.showZoomOverlay,
      zoomOverlayContent = props.zoomOverlayContent;
  var landscape = props.landscape;

  var total = _react["default"].Children.count(children);

  var pixels = size && !minimal ? sizeMap[size].pxWidth : pxSize;
  var allowNavigation = minimal && total > 1 || !minimal && total > sizeMap[size].maxThumbs;
  /**
   * State and control for slides
   */

  var _useState = (0, _react.useState)({
    currentSlide: props.currentSlide > _react["default"].Children.count(props.children) - 1 ? 0 : props.currentSlide,
    previousSlide: null,
    transitioning: false,
    timer: null,
    direction: ''
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      slideState = _useState2[0],
      setSlideState = _useState2[1];

  var clearPendingAnimation = function clearPendingAnimation() {
    if (slideState.timer) {
      clearTimeout(slideState.timer);
    }
  };

  var endAnimation = function endAnimation() {
    return setTimeout(function () {
      return setSlideState(function (prevState) {
        return _objectSpread({}, prevState, {
          previousSlide: null,
          transitioning: false
        });
      });
    }, 600);
  };

  var goToSlide = function goToSlide(nextSlide, direction) {
    if (nextSlide === slideState.currentSlide) {
      return;
    }

    clearPendingAnimation();

    if (!direction) {
      direction = nextSlide > slideState.currentSlide ? 'next' : 'prev'; // eslint-disable-line no-param-reassign
    }

    setSlideState(function (prevState) {
      return _objectSpread({}, prevState, {
        direction: direction,
        previousSlide: prevState.currentSlide,
        currentSlide: nextSlide,
        transitioning: true,
        timer: endAnimation()
      });
    });
    props.onSlideChanged && props.onSlideChanged(nextSlide);
  };

  var goToNextSlide = function goToNextSlide() {
    var nextSlide = slideState.currentSlide + 1;

    if (nextSlide >= _react["default"].Children.count(props.children)) {
      nextSlide = 0;
    }

    goToSlide(nextSlide, 'next');
  };

  var goToPreviousSlide = function goToPreviousSlide() {
    var nextSlide = slideState.currentSlide > 0 ? slideState.currentSlide - 1 : _react["default"].Children.count(props.children) - 1;
    goToSlide(nextSlide, 'prev');
  };
  /**
   * State and controls for thumbnails
   */


  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      thumbsPosition = _useState4[0],
      setThumbsPosition = _useState4[1];

  var goToThumbs = function goToThumbs(direction) {
    var newThumbsPosition = thumbsPosition;
    var totalLength = _react["default"].Children.count(children) * THUMBNAIL_WIDTH;
    var thumbsWidth = sizeMap[size].maxThumbs * THUMBNAIL_WIDTH;
    var loopPosition = direction === 'next' ? 0 : (Math.floor(totalLength / thumbsWidth) - 1) * thumbsWidth * -1;
    direction === 'next' ? newThumbsPosition -= thumbsWidth : newThumbsPosition += thumbsWidth;
    newThumbsPosition = Math.abs(newThumbsPosition) >= totalLength || newThumbsPosition > 0 ? loopPosition : newThumbsPosition;
    setThumbsPosition(newThumbsPosition);
  };

  var goToNextThumbs = function goToNextThumbs() {
    return goToThumbs('next');
  };

  var goToPreviousThumbs = function goToPreviousThumbs() {
    return goToThumbs('prev');
  };

  if (minimal) {
    // just in case
    landscape = false;
  }

  var currentSlide = slideState.currentSlide,
      direction = slideState.direction,
      previousSlide = slideState.previousSlide,
      transitioning = slideState.transitioning;

  var slides = _react["default"].Children.map(props.children, function (child, i) {
    return _react["default"].createElement(_CarouselSlide["default"], {
      active: i === currentSlide,
      index: i,
      animateOut: i === previousSlide && transitioning,
      animateIn: i === currentSlide && previousSlide !== null && transitioning,
      direction: direction,
      onCarouselClick: onCarouselClick,
      showZoomOverlay: showZoomOverlay,
      zoomOverlayContent: zoomOverlayContent
    }, child);
  });

  return _react["default"].createElement("div", {
    style: landscape ? {
      height: "".concat(pixels, "px"),
      display: 'flex',
      flexDirection: 'row-reverse',
      width: 'fit-content'
    } : {
      width: "".concat(pixels, "px")
    }
  }, _react["default"].createElement("div", {
    style: landscape ? {
      width: "".concat(pixels, "px")
    } : {
      height: "".concat(pixels, "px")
    }
  }, _react["default"].createElement("div", {
    className: "carousel slide"
  }, _react["default"].createElement("div", {
    className: "carousel-inner",
    role: "listbox"
  }, loading ? _react["default"].createElement(_CarouselLoading["default"], {
    size: pixels
  }) : slides && slides.length ? slides : fallbackPreview))), !hideIndicators && _react["default"].createElement("div", {
    className: "carousel-navigation".concat(minimal ? ' carousel-navigation-small' : '').concat(landscape ? ' carousel-navigation-vertical' : '')
  }, _react["default"].createElement(_CarouselControl["default"], {
    disabled: !allowNavigation,
    onClick: minimal ? goToPreviousSlide : goToPreviousThumbs,
    large: !minimal,
    direction: landscape ? 'up' : 'left',
    hintText: "Previous"
  }), _react["default"].createElement("ol", {
    className: "carousel-indicators",
    style: minimal ? {
      height: 'auto',
      overflow: 'visible'
    } : {}
  }, total && !minimal ? _react["default"].Children.map(children, function (child, i) {
    return _react["default"].createElement(_CarouselIndicator["default"], {
      slideNumber: i,
      active: currentSlide === i,
      goToSlide: goToSlide,
      offset: landscape ? {
        top: thumbsPosition
      } : {
        left: thumbsPosition
      }
    }, loading ? null : child);
  }) : minimal ? _react["default"].createElement("div", {
    className: "small"
  }, total > 0 ? "".concat(currentSlide + 1, " / ").concat(total) : '– / –') : _react["default"].createElement("li", {
    disabled: true,
    style: {
      backgroundColor: _colors.horizon
    }
  })), _react["default"].createElement(_CarouselControl["default"], {
    disabled: !allowNavigation,
    onClick: minimal ? goToNextSlide : goToNextThumbs,
    large: !minimal,
    direction: landscape ? 'down' : 'right',
    hintText: "Next"
  })));
};

Carousel.propTypes = {
  size: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl']),
  pxSize: _propTypes["default"].number,
  minimal: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  loading: _propTypes["default"].bool,
  onCarouselClick: _propTypes["default"].func,
  currentSlide: _propTypes["default"].number,
  fallbackPreview: _propTypes["default"].node,
  landscape: _propTypes["default"].bool,
  onSlideChanged: _propTypes["default"].func,
  hideIndicators: _propTypes["default"].bool,
  showZoomOverlay: _propTypes["default"].bool,
  zoomOverlayContent: _propTypes["default"].node
};
Carousel.defaultProps = {
  size: 'm',
  pxSize: 200,
  minimal: false,
  currentSlide: 0,
  fallbackPreview: _react["default"].createElement(_CarouselFallback["default"], null),
  landscape: false,
  hideIndicators: false,
  showZoomOverlay: false
};
var _default = Carousel;
exports["default"] = _default;